<template>
    <div v-if="view" class="user_item_list_form">
        <div class="user_item_list_form_body">
            <span class="item_name" v-if="userItem.item.name">
                <img :src="userItem.item.image_path">
                <a :href="'/items/' + userItem.item.id">
                    {{ userItem.item.name }}
                </a>
            </span>

            <Dropdown
                v-model="formData.userItemPossession"
                :options="userItemPossessions"
                optionValue="code"
                optionLabel="name"
                placeholder="Select Have"
                class="user-item-possession"
                />

            <Dropdown v-model="formData.userItemList" :options="userItemLists" placeholder="UserItemListName" :editable="true" />

            <Button
                type="button"
                v-bind:label="button_label"
                class="p-button-outlined"
                @click="onClickUpsert"
                />

            <Button
                type="button"
                icon="pi pi-times"
                :label="$t('Delete')"
                class="p-button-danger p-button-outlined"
                @click="onClickDelete($event)"
                />

            <ConfirmPopup></ConfirmPopup>
        </div>
        <div class="memo">
            <Textarea id="memo" v-model="formData.memo" :autoResize="true" rows="5" cols="30" />
        </div>
    </div>
</template>

<script>
import {
    ref,
    onMounted,
    reactive,
    computed,
} from 'vue';
import axios from "axios";
import Message from 'primevue/message';

import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Dropdown from 'primevue/dropdown';
import AutoComplete from 'primevue/autocomplete';
import ConfirmPopup from 'primevue/confirmpopup';
import Textarea from 'primevue/textarea';

import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";

import { trans } from 'laravel-vue-i18n';

export default {
    components: {
        Message,
        Button,
        InputText,
        Dropdown,
        AutoComplete,
        ConfirmPopup,
        Textarea,
    },
    props: {
        user_item_id: {
            type: String,
            default: ""
        },
        user_item_list: {
            type: String,
            default: ""
        },
        user_item_list: {
            type: String,
            default: ""
        },
        button_label: {
            type: String,
            default: 'Save'
        },
        button_delete_label: {
            type: String,
            default: 'Delete'
        }
    },
    setup(props) {

        const toast = useToast();
        const confirm = useConfirm();

        const errors = ref([]);

        const formData = reactive({
            userItemPossession: 0,
            userItemList: "",
            memo: "",
        })

        const userItemPossessions = ref();
        const userItemLists = ref();
        const buttonLabel = ref();
        const buttonDeleteLabel = ref();
        const view = ref(true);

        const userItem = ref({
            id: 0,
            item: {
                name: ''
            }
        });

        const load = () => {
            userItem.value = JSON.parse(document.getElementById("json-data-user-item-" + props.user_item_id).textContent)
            userItemPossessions.value = JSON.parse(document.getElementById("json-data-user-item-possessions").textContent)
            userItemLists.value = JSON.parse(document.getElementById("json-data-user-item-lists").textContent)

            formData.userItemList = props.user_item_list;
            formData.userItemPossession = userItem.value.possession;
            formData.memo = userItem.value.memo;

            buttonLabel.value = props.button_label;
            buttonDeleteLabel.value = props.button_delete_label;

        }

        onMounted(load);

        const InsertOrUpdate = function() {
            const postData = {
                item_id: userItem.value.item_id,
                possession: formData.userItemPossession,
                user_item_list_name: formData.userItemList,
                memo: formData.memo,
            }
            axios.post(
                '/api/user/items',
                postData,
            ).then(res => {
                toast.add({severity:'info', summary: 'Update', detail:'User Item List Update', life: 3000});
                if(formData.userItemList != props.user_item_list) {
                    view.value = false
                }

                errors.value = {}
            }).catch(error => {
                //toast.add({severity:'error', summary: 'Error', detail: error.response.data.errors, life: 3000});
                //errors.value = error.response.data.errors
            })
        }

        const onClickUpsert = function() {
            InsertOrUpdate()
        }

        const onClickDelete = (event) => {
            confirm.require({
                target: event.currentTarget,
                message: trans('Do you want to delete this item?'),
                icon: 'pi pi-info-circle',
                acceptClass: 'p-button-danger',
                accept: () => {
                    userItemDelete();
                },
                reject: () => {
                }
            });
        }

        const userItemDelete = () => {
            axios.delete(
                '/api/user/items/' + userItem.value.id,
            ).then(res => {
                toast.add({severity:'info', summary: 'Update', detail:'User Item List Delete', life: 3000});
                errors.value = {}
                view.value = false
            }).catch(error => {
                errors.value = error.response.data.errors
            })
        }

        return {
            errors,
            onClickUpsert,
            onClickDelete,
            formData,
            userItemPossessions,
            userItemLists,
            buttonLabel,
            buttonDeleteLabel,
            view,
            userItem,
        }
    },
}
</script>

